import { render, staticRenderFns } from "./IcoPlayTriangleOrbit.vue?vue&type=template&id=7ac73629"
import script from "./IcoPlayTriangleOrbit.vue?vue&type=script&lang=js"
export * from "./IcoPlayTriangleOrbit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports